import React from 'react';
import { CheckCircle2, PlayCircle } from 'lucide-react';
export function HeroSection() {
  const handleCheckout = () => {
    window.location.href = 'https://productosdigitalesnuevos.myshopify.com/checkouts/cn/hWN9n9b8dLQ0zWcM4lh6BQg6/es-ar?_r=AQAB3sxDrVfYMB8G5oC3KtOEXxVl3WNVcpKRPbVzMknQ1i0&cart_link_id=QdC5wTSR&preview_theme_id=146146721979';
  };
  const scrollToSolution = () => {
    document.getElementById('solution')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-55">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-56">
        <img src="https://cdn.magicpatterns.com/uploads/1j3YCQsFR3hbv9MGvG8eUu/ChatGPT_Image_11_mar_2026,_12_18_40_a.m..png" alt="Postres en vaso deliciosos" className="w-full h-full object-cover opacity-40" data-id="element-57" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0d0906]/80 via-[#0d0906]/60 to-[#0d0906]" data-id="element-58"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-5xl" data-id="element-59">
        <div className="text-center max-w-3xl mx-auto" data-id="element-60">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full border border-[#d4a843]/30 bg-[#d4a843]/10 text-[#f0c14b] text-sm font-semibold tracking-wide uppercase" data-id="element-61">
            Curso Online Completo
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight" data-id="element-62">
            Empezá tu Negocio de{' '}
            <span className="gold-gradient-text" data-id="element-63">Postres en Vaso</span> Hoy
          </h1>

          <p className="text-xl md:text-2xl text-[#c9b99a] mb-10 leading-relaxed" data-id="element-64">
            Aprendé las recetas más rentables y empezá a vender desde tu casa,
            sin experiencia previa.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-65">
            <button onClick={handleCheckout} className="btn-gold animate-shimmer-btn w-full sm:w-auto" data-id="element-66">
              Quiero Empezar Ahora
            </button>
            <button onClick={scrollToSolution} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white border border-white/20 rounded-full hover:bg-white/5 transition-colors w-full sm:w-auto" data-id="element-67">
              <PlayCircle className="w-5 h-5 mr-2" data-id="element-68" />
              Ver Cómo Funciona
            </button>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-[#c9b99a]" data-id="element-69">
            <div className="flex items-center" data-id="element-70">
              <CheckCircle2 className="w-5 h-5 text-[#d4a843] mr-2" data-id="element-71" />
              <span data-id="element-72">Acceso inmediato</span>
            </div>
            <div className="flex items-center" data-id="element-73">
              <CheckCircle2 className="w-5 h-5 text-[#d4a843] mr-2" data-id="element-74" />
              <span data-id="element-75">Garantía 30 días</span>
            </div>
            <div className="flex items-center" data-id="element-76">
              <CheckCircle2 className="w-5 h-5 text-[#d4a843] mr-2" data-id="element-77" />
              <span data-id="element-78">+500 alumnos</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}